import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  // Stop mobile browsers from restoring previous scroll position on SPA navigation
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    const scrollEl = document.scrollingElement || document.documentElement;

    const scrollTopNow = () => {
      // cover most browsers + iOS quirks
      window.scrollTo(0, 0);
      if (scrollEl?.scrollTo) scrollEl.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    };

    // No hash → always go top (do it a couple times to beat mobile timing quirks)
    if (!hash) {
      scrollTopNow();
      requestAnimationFrame(scrollTopNow);
      setTimeout(scrollTopNow, 50);
      return;
    }

    // Hash present → scroll to the element once it exists
    const id = hash.replace("#", "");

    // Try immediately
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    // If element not ready yet (route just changed), try again shortly
    scrollTopNow();
    const t = setTimeout(() => {
      const el2 = document.getElementById(id);
      if (el2) el2.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 200);

    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
};
